import Businesses from '@/pages/Businesses'

export default {
    path: '/shops',
    name: 'Businesses',
    component: Businesses
}


// WEBPACK FOOTER //
// ./src/router/businesses.js